import { Dayjs } from "dayjs";
import { number } from "echarts";
import { dayjs } from "lib/date/dayjsUTC";

export const defaultBeforeDate = dayjs.utc().unix();
// way to set 0001-01-01T00:00:00
export const defaultAfterDate = 1;

export const dayjsToAPI = (
  date: Dayjs | number | string = defaultBeforeDate
) => {
  if (date instanceof dayjs) {
    //Note: standard ISO8601 format() adds timezone with + which needs to be escapped for sending it as parameter
    // so better to stick to the following defaut UTC without specific timezone
    return (date as Dayjs).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
  }

  if (typeof date != "number") {
    switch (typeof date) {
      case "number":
        return date as unknown as string;
      case "string":
        return date;
      // case Dayjs:
      //   return (date as Dayjs).utc().format();
      default:
        return (date as Dayjs).utc().format();
    }
  }

  return ("" + date) as string;

  // if (
  //   typeof date != "number"
  //   && typeof date != "string"
  //   && date != defaultAfterDate
  // ) {
  //   // return date.utc().format("YYYY-MM-DD_HH:mm:ss");
  //   return date.utc().format();
  // } else if (
  //   typeof date != "number"
  //   && typeof date != "string"
  //   && date == defaultAfterDate
  // ) {
  //   // return date.format("YYYY-MM-DD_HH:mm:ss");
  //   return date.format();
  // } else {
  //   return date as unknown as string;
  // }
};

// TODO: use dayjsUTC
